// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"f0c9b983","239":"91fd7770","453":"97e81b47","455":"b7666d53","977":"f98d3f34"}[chunkId] + ".chunk.js";
};